export default __webpack_public_path__ + "static/media/Fees.28e8eee4.png";